module.exports = __webpack_public_path__ + "images/error-insights-5e5f0fbe.svg";